var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmcheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9596 38.0404L25.6667 38.7476L26.3738 38.0404L39.2071 25.2071L37.7929 23.7929L25.6667 35.9191L19.3738 29.6262L17.9596 31.0404L24.9596 38.0404ZM48 30.3333C48 41.379 39.0457 50.3333 28 50.3333C16.9543 50.3333 8 41.379 8 30.3333C8 19.2876 16.9543 10.3333 28 10.3333C39.0457 10.3333 48 19.2876 48 30.3333Z",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 56,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4.66668C13.8247 4.66668 2.33333 16.158 2.33333 30.3333H0V2.33334H56V30.3333H53.6667C53.6667 16.158 42.1753 4.66668 28 4.66668Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 14C21 19.1546 16.8213 23.3333 11.6667 23.3333C6.512 23.3333 2.33333 19.1546 2.33333 14C2.33333 8.84533 6.512 4.66666 11.6667 4.66666C16.8213 4.66666 21 8.84533 21 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6667 14C53.6667 19.1546 49.488 23.3333 44.3333 23.3333C39.1787 23.3333 35 19.1546 35 14C35 8.84533 39.1787 4.66666 44.3333 4.66666C49.488 4.66666 53.6667 8.84533 53.6667 14Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmcheck);
export default __webpack_public_path__ + "static/media/alarmcheck.15b70d43d950ed9eedb66383a6877b3b.svg";
export { ForwardRef as ReactComponent };